module.exports = __webpack_public_path__ + "media/images/banner/kickstarter/foodbook_banner_v4-40bba773cd65025db0fdf6e5f4af739e.jpeg";